import { render, staticRenderFns } from "./Estates.vue?vue&type=template&id=8c3b1ce8&"
import script from "./Estates.vue?vue&type=script&lang=js&"
export * from "./Estates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports